<template>
  <plugin-layout>
    <template v-if="plugin">
      <plugin-editions :plugin="plugin" />
    </template>
  </plugin-layout>
</template>

<script setup lang="ts">
  import {useRoute} from 'vue-router';
  import PluginLayout from '../../components/PluginLayout.vue';
  import PluginEditions from '../../components/PluginEditions.vue';
  import {useHelpers} from '~/composables/useHelpers';
  import {
    computed,
    definePageMeta,
    useAppStore,
    useAsyncData,
    usePluginStoreStore,
  } from '#imports';

  definePageMeta({
    layout: 'site',
  });

  const route = useRoute();

  const pluginStoreStore = usePluginStoreStore();
  const appStore = useAppStore();
  const {isPluginFree} = useHelpers();

  const plugin = computed(() => pluginStoreStore.plugin);

  await useAsyncData(async () => {
    if (
      pluginStoreStore.plugin &&
      pluginStoreStore.plugin.handle === route.params.handle
    ) {
      const plugin = pluginStoreStore.plugin;

      if (isPluginFree(plugin) || plugin.editions.length <= 1) {
        throw createError({statusCode: 404, message: 'Page not found'});
      }
    } else {
      pluginStoreStore.updatePluginDetails(null);

      await pluginStoreStore
        .getPluginDetailsByHandle(route.params.handle)
        .then(() => {
          const plugin = pluginStoreStore.plugin;

          if (isPluginFree(plugin) || plugin.editions.length <= 1) {
            throw createError({statusCode: 404, message: 'Page not found'});
          }

          appStore.updatePageMeta({
            title: plugin.name,
            description: plugin.shortDescription,
          });
        })
        .catch((errorMsg) => {
          if (errorMsg === "Couldn't find plugin") {
            throw createError({statusCode: 404, message: errorMsg});
          } else {
            throw errorMsg;
          }
        });
    }
  });
</script>
